<template lang="pug">
    Modal
        div
        .form
            h2(
              v-if="!selectedUser"
            ) Create a New User
            h2(
              v-if="selectedUser"
            ) Manage User
            .form__control-group
                label Email Address
                input(
                    v-model="primary_email"
                    type="email"
                )
                p.validation__error(
                    v-if="errors.primary_email"
                ) Please enter a valid email address.
            .form__control-group.form__control-group--half
                label First Name
                input(
                    v-model="profile.name.first"
                    type="text"
                )
                p.validation__error(
                    v-if="errors.profile.name.first"
                ) Please enter a first name.
            .form__control-group.form__control-group--half
                label Last Name
                input(
                    v-model="profile.name.last"
                    type="text"
                )
                p.validation__error(
                    v-if="errors.profile.name.first"
                ) Please enter a first name.
            .form__control-group.form__control-group--half
                label Role
                select(
                    v-model="role"
                )
                    option(
                        :value="role._id"
                        v-for="role in roles"
                    ) {{ role.title }}
            .form__control-group.form__control-group--half
                label Status
                select(
                    v-model="status"
                )
                    option(
                        :value="status"
                        v-for="(status, index) in statuses"
                    ) {{ status }}
            .form__control-group
                button.button__submit(
                    @click="submit"
                    v-if="!selectedUser"
                ) Create User
                button.button__submit(
                    @click="submit"
                    v-if="selectedUser"
                ) Save
</template>
<script>
import Modal from '../general/Modal';
import store from '../../store';
import { postResource } from '../../services/Utils';
import Services from '../../services/Services';
import VueNotifications from 'vue-notifications';
export default {
  name: 'ManageUser',
  components: {
    Modal
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: '',
      icon: '❗️'
    }
  },
  props: ['selectedUser', 'close', 'refreshUsers', 'roles'],
  computed: {
    getRoles() {
      return ['admin', 'read', 'write'];
    }
  },
  methods: {
    submit() {
        const body = {
            primary_email: this.primary_email,
            profile: {
                name: {
                    first: this.profile.name.first,
                    last: this.profile.name.last,
                }
            },
            role:  this.role,
            status: this.status
        }

        if(!this.selectedUser) {
            body.domain = store.getters.getDomain;
        }
        const action = this.selectedUser ? '/v1/users/update' : '/v1/users/create';
        const query = this.selectedUser ? `id=${this.selectedUser._id}` : false;

        console.log(body);
        console.log(query);
        postResource(action, query, body)
            .then((res) => {

                if(this.selectedUser){
                    this.showSuccessMsg({
                        message: `User updated!`
                    });
                } else {
                    this.showSuccessMsg({
                        message: `User created and sent password link!`
                    });
                }
            })
            .then(() => {
                this.refreshUsers();
                this.close('manageUser');
            })
            .catch(error => {
               console.log(error)
            })
    }
  },
  data() {
    return {
      profile: {
        name: {
          first: null,
          last: null
        }
      },
      primary_email: '',
      role: '',
      status: '',
      statuses: ['active', 'suspended', 'disabled', 'removed'],
      resetState: false,
      errors: {
        primary_email: false,
        profile: {
          name: {
            first: false,
            last: false
          }
        }
      }
    };
  },
  mounted() {
    console.log(this.selectedUser || 'new user');
    if (!this.selectedUser) {
      this.status = 'active';
    } else {
        this.status = this.selectedUser.status;
        this.primary_email = this.selectedUser.primary_email;
        this.role = this.selectedUser.role;
        this.profile = this.selectedUser.profile;
        this.role = this.selectedUser.role;
    }
  }
};
</script>
<style lang="scss" scoped>
.form {
  padding: 2rem 1rem;
  display: flex;
  justify-content: center;
  flex-direction: row;
  flex-wrap: wrap;

  h2 {
    text-align: center;
    width: 100%;
  }

  .form__control-group {
    display: flex;
    flex-direction: column;
    padding: 0 1rem;
    margin-bottom: 1rem;
    width: 100%;

    @media all and (min-width: 1024px) {
      &--half {
        width: 50%;
      }
    }

    label {
      margin-bottom: 5px;
    }

    &:after {
      top: 20px !important;
    }

    input {
      padding-left: 0.5rem;
      height: 40px;
    }

    div {
      padding: 10px;
      display: flex;
      flex-flow: row nowrap;

      &:nth-of-type(odd) {
        background: #e8ffff;
      }

      span.role-label {
        margin-right: auto;

        i {
          color: #888;
        }

        span {
          margin-left: 10px;
        }
      }

      select {
        text-transform: capitalize;
        width: 100px;

        option {
          text-transform: capitalize;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/ManageUser.vue